export default "__VITE_ASSET__C8yDPZ6u__"